import { Constants } from '../../constants/constants';
import { Component, OnInit } from '@angular/core';

import { EstructuraControlService } from '../../servicios/estructura-control.service';
import { SetFormService } from '../../servicios/set-form.service';
import { FormTextbox } from '../../model-form/form-textbox';
import { FormDropdown } from '../../model-form/form-dropdown';
import { EstructuraBase } from '../../model-form/estructura-base';
import { Utils } from '../../utils/utils';

@Component({
  selector: 'app-creacionpersona',
  templateUrl: './creacionpersona.component.html',
  styleUrls: ['./creacionpersona.component.css']
})
export class CreacionpersonaComponent implements OnInit {

  items: EstructuraBase<any>[];
  descripcion: string;
  idFormulario = 25;
  parametrosDestino: any[] = [];
  procedimientoDestino: string = '';

  constructor(
    servicioFormulario: SetFormService,
    public ruta: Utils,
    private formatFormulario: Utils
  ) {
    this.descripcion = 'Creación De Usuario';
    let response: any;

    servicioFormulario.getFormulario(this.idFormulario).subscribe(data => {
      this.procedimientoDestino = data[0].procedimientoDestino;
      response = this.formatFormulario.formatFormulario(data);
      this.items = response.arrayDatos;
      this.parametrosDestino = response.parametros;

      return this.items.sort((a, b) => a.order - b.order);
    });
  }

  ngOnInit() {
    //this.ruta.setRuta();
  }
}
